var style = {"z-sponsored-tag":"z-sponsored-tag","z-sponsored-tag__icon":"z-sponsored-tag__icon"};

export { style as default };
//# sourceMappingURL=SponsoredTag.module.scss.js.map
